import {
  // CogIcon,
  // ChartBarIcon,
  CpuChipIcon,
  HomeIcon,
  // BoltIcon,
  PuzzlePieceIcon,
  CommandLineIcon,
  VideoCameraIcon,
  // SquaresPlusIcon,
  PlusIcon,
} from '@heroicons/react/24/outline';

interface NavigationBase {
  name: string;
  icon?: any;
  current?: boolean;
}

export interface NavigationLink extends NavigationBase {
  href: string;
  children?: never;
}

interface NavigationGroup extends NavigationBase {
  href?: never;
  children: NavigationLink[];
}

export type NavigationItem = NavigationLink | NavigationGroup;

export const CUSTOM_TYPES_NAME = 'Types';

const navigationItems: NavigationItem[] = [
  { name: 'Dashboard', href: '/', icon: HomeIcon },
  {
    name: 'Channels',
    href: '/channels',
    icon: VideoCameraIcon,
  },
  {
    name: CUSTOM_TYPES_NAME,
    icon: PuzzlePieceIcon,
    children: [
      {
        name: 'New type',
        href: '/types/new',
        icon: PlusIcon,
      },
    ],
  },
  // {
  //   name: 'Visual Manager',
  //   href: '/views',
  //   icon: SquaresPlusIcon,
  // },
  // { name: 'Events', href: '/events', icon: BoltIcon },
  { name: 'Bots', href: '/bots', icon: CpuChipIcon },
  {
    name: 'Chat messages',
    icon: CommandLineIcon,
    children: [
      { name: 'Commands', href: '/commands' },
      { name: 'Timers', href: '/timers' },
    ],
  },
  // { name: 'Analytics', href: '/analytics', icon: ChartBarIcon },
  // { name: 'Settings', href: '/settings', icon: CogIcon },
];

export default navigationItems;
